import { ScopedURLBuilder } from 'utils/linkUtils';

const builder = new ScopedURLBuilder('snapchat://discover/');

export const edition = builder.createAPICall('edition', {
  query: ['publisher', 'edition_id', 'profileId'],
  convertQueryCasing: (arg: any) => arg,
});
